import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import InvitationPremium from "@/pages/InvitationPremium";
import Invitation from "@/pages/Invitation";

/**
 * Unified public invitation route. The couple gets ONE link (/u/:pid).
 * Anyone opening it sees the invitation using whichever template the couple
 * activated — standard OR premium — automatically. No template picker for
 * guests.
 */
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicInvitation() {
  const { pid } = useParams();
  const [kind, setKind] = useState(undefined); // undefined = loading; 'standard' | 'premium' | 'error'

  useEffect(() => {
    let mounted = true;
    axios.get(`${API}/public/invitation/${pid}`)
      .then((r) => {
        if (!mounted) return;
        const k = r.data?.active_kind || (r.data?.premium_template ? "premium" : "standard");
        setKind(k === "standard" ? "standard" : "premium");
      })
      .catch(() => mounted && setKind("error"));
    return () => { mounted = false; };
  }, [pid]);

  if (kind === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0a0705] text-white" data-testid="unified-loading">
        <p className="text-xl italic" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Memuat undangan…</p>
      </div>
    );
  }
  if (kind === "error") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0a0705] text-white" data-testid="unified-error">
        <p className="text-xl">Undangan tidak ditemukan</p>
      </div>
    );
  }
  return kind === "premium" ? <InvitationPremium /> : <Invitation />;
}
